export default {
    personalLoan: {
        expired: {
            title: 'Sorry, your loan offer has expired',
            subtitle:
                'Click below to refresh your application and loan offer. If you have any other questions, please reach out to us via <0>Fig live chat</0> to the bottom right of this page or <1>email Fig support</1>.',
            buttonText: 'Start again'
        },
        partnerUnavailable: {
            title: 'A new chapter for Fig is coming soon',
            notOffering: 'Fig is not offering new personal loans through this channel at this time.',
            newProducts: 'We’re working on new products designed to help Canadians manage their money and reach their financial goals faster.',
            closing: 'We helped you Borrow Better. Now, we’re building what’s next.'
        },
        schema: {
            errorMessages: {
                loanAmount: 'Loan amount must be between {{minLoanAmount}} and {{maxLoanAmount}}',
                loanTermInMonths: 'Loan term must be between 12 and 84 months',
                loanPurpose: 'Please select a loan purpose',
                loanPurposeOther: 'Please specify your loan purpose'
            }
        },
        flinksBankInvalid: {
            title: 'Let’s try another account',
            content:
                'We are unable to proceed with this bank account. Please validate that you are using your primary personal bank account. If you have any questions, contact us via <liveChatLink>Fig live chat</liveChatLink> to the bottom right of this page or <supportLink>support@fig.ca</supportLink>.',
            buttonText: 'Connect a different account'
        },
        flinksBankInvalidPiiMismatch: {
            title: 'Let’s try another account',
            content:
                'The name on this bank account doesn’t match the name on your application. To continue, please connect a bank account in your name. If you have any questions, contact us via <liveChatLink>Fig live chat</liveChatLink> to the bottom right of this page or <supportLink>support@fig.ca</supportLink>.',
            buttonText: 'Connect a different account'
        },
        flinksBankInvalidIncomeRuleFail: {
            title: 'Let’s try another account',
            content:
                'We are unable to proceed with this bank account. Please validate that you are using your primary personal bank account. If you have any questions, contact us via <liveChatLink>Fig live chat</liveChatLink> to the bottom right of this page or <supportLink>support@fig.ca</supportLink>.',
            buttonText: 'Connect a different account'
        },
        embeddedOfferStep: {
            offerExpiry: 'Offer expires {{date}}',
            progressBarEstimate: 'Just a few minutes to finish',
            loanAmountDisclaimer: {
                title: 'Pre-approval personal loan offer',
                content:
                    "A pre-approved offer means your loan amount and interest rate are locked in. Based on the information you've provided, you're pre-approved for up to {{loanAmount}} at a fixed interest rate of {{apr}}. Additional details will be required to finalize your approval.<br/><br/> You'll be able to choose the exact amount you want to borrow (up to the pre-approved limit) on the next screen. As this is a loan and not a line of credit, the amount you choose will be deposited into your bank account upon completing the loan booking process."
            },
            disclaimerText: "By continuing, you agree to Fig Financial Inc's <0>Terms and Conditions</0> and <1>Privacy Statement</1>."
        },
        embeddedPhoneNumberStep: {
            title: "What's your phone number?",
            subtitle: 'This helps us verify your identity, assess your application and contact you only with important updates or support. ',
            errorMessage: 'Please enter a valid phone number'
        },
        customizeYourOfferStep: {
            title: 'Customize your offer',
            subtitle: 'Select loan amount and term that suit your needs',
            loanTermLabel: 'years',
            loanAmount: {
                label: 'Loan Amount',
                title: 'Enter the amount you want to borrow',
                placeholder: 'Enter loan amount',
                sliderLabel: 'Loan Amount Slider',
                sliderTitle: 'Adjust loan amount using the slider'
            },
            loanTerm: {
                sliderLabel: 'Loan Term in Months',
                sliderTitle: 'Select loan term in months using the slider',
                monthlyPaymentLabel: 'Monthly Payment'
            },
            benefitsSection: {
                fig: 'Interested in early repayment? Fig does not charge any penalties for early repayments',
                kizzo: 'Interested in early repayment? We do not charge any penalties for early repayments'
            },
            tooltip: {
                title: 'Monthly Payment',
                content:
                    'Monthly payment shown is estimated and may slightly differ from actual amount owed. <br/><br/> Fig doesn’t charge any fees on early repayment. If you make a lump-sum payment, your monthly payment will remain the same but you’ll be paying off your loan earlier than the selected term.'
            }
        },
        confirmPaymentScheduleStep: {
            title: "Let's confirm your payment schedule",
            subtitle: 'Choose a payment frequency that works for you',
            paymentScheduleSection: {
                title: 'Your payment schedule',
                monthlyDescription: "We'll withdraw {{amount}} on the {{day}} of every {{frequency}}",
                weeklyDescription: "We'll withdraw {{amount}} {{frequency}}",
                biweeklyDescription: "We'll withdraw {{amount}} {{frequency}}",
                disclaimer: 'Starting on {{startDate}}',
                changeButtonText: 'Change payment schedule',
                frequency: {
                    EVERY_WEEK: 'weekly',
                    EVERY_TWO_WEEKS: 'every 2 weeks',
                    ONCE_A_MONTH: 'month'
                }
            },
            paymentSchedule: {
                label: 'Payment Schedule',
                weekly: 'Weekly',
                biWeekly: 'Bi-Weekly',
                monthly: 'Monthly'
            },
            cta: {
                buttonText: 'Continue'
            }
        },
        editPaymentScheduleStep: {
            title: 'Change your payment schedule',
            subtitle: 'How often would you like to make payments?',
            mapping: {
                every_week: 'every week',
                every_two_weeks: 'every 2 weeks',
                once_a_month: 'of every month'
            },
            options: {
                weekly: 'Every week',
                biweekly: 'Every 2 weeks',
                monthly: 'Once a month'
            },
            monthlyOptions: {
                firstOfMonth: '1st of the month',
                fifteenthOfMonth: '15th of the month',
                lastDayOfMonth: 'Last day of the month',
                other: 'Other',
                chooseDate: 'Choose a date'
            },
            whenWouldYouLikeToMakePayments: 'When would you like to make payments?',
            dateLabel: 'Select a date',
            saveScheduleButtonText: 'Save schedule',
            cancelButtonText: 'Cancel',
            selectFirstPaymentDate: 'Select first payment date',
            paymentSchedule: {
                title: 'Your Payment Schedule',
                description: 'We will withdraw {{amount}} every {{frequency}}',
                startingOn: 'Starting on {{date}}'
            },
            paymentScheduleDetails: {
                title: 'Your payment schedule',
                monthlyDescription: "We'll withdraw {{amount}} on the {{day}} {{frequency}}",
                weeklyDescription: "We'll withdraw {{amount}} {{frequency}}",
                biweeklyDescription: "We'll withdraw {{amount}} {{frequency}}",
                startingOn: 'Starting on {{date}}'
            }
        },
        paymentProtectionStep: {
            title: 'Protect your payments against unexpected life events',
            subtitle:
                "We're here to help you and your family stay financially on track when it matters most. The optional Payment Protection Plan underwritten by Trans Global Insurance Company and Trans Global Life Insurance Company protects you against:",
            factSheetUrl: 'https://fig.ca/documents/LPPP-Product-Summary-and-Fact-Sheet-QC-Mar-25_EN.pdf',
            testimony: {
                content:
                    "'When my husband’s health problems kept him out of work for a prolonged period of time, TGI's Payment Protection Plan was there to see us through the hard times. I would most definitely recommend TGI's Payment Protection Plan. '",
                name: '- Mary A'
            },
            LinksText: {
                termsLink: 'Terms',
                faqLink: 'FAQs',
                factSheetLink: 'Product Summary and Fact Sheet'
            },
            FirstAccordion: {
                title: 'Involuntary unemployment or disability',
                subtitle: 'Could cover your loan payments up to 12 months',
                pointone: 'Covers 100% of your regular monthly payments, for up to 12 months and a maximum of $35,000',
                pointtwo: 'Involuntary unemployment coverage for both full-time employed and self-employed borrowers (working 25+ hours per week)',
                pointthree:
                    'Disability coverage for borrowers who become totally and continuously disabled (for more than 30 consecutive days) as the result of accidental bodily injury or sickness, preventing them from working'
            },
            SecondAccordion: {
                title: 'Critical illness or life with dismemberment',
                subtitle: 'Could cover your oustanding balance',
                pointone: 'Covers your outstanding balance up to a maximum of $35,000',
                pointtwo: 'Available to the primary borrower and their spouse',
                pointthree:
                    'Critical illnesses covered: cancer (life threatening), heart attack, stroke, coronary artery bypass graft, kidney failure and major organ transplant',
                pointfour: 'Critical Illness coverage ceases at the age of 65',
                pointfive:
                    'Dismemberment: irrevocable loss of the entire sight of both eyes or a hand or foot by complete severance through or above the wrist or ankle joint'
            },
            FirstBox: {
                title: 'Recommended',
                subtitle: 'Enroll me now for {{insuranceAmount}} {{frequency}}',
                subtitle1: 'Cancel anytime'
            },
            SecondBox: {
                title: 'I decline protection for my',
                title1: ' {{loanAmt}} ',
                title2: 'loan'
            },
            disclaimer: {
                ROC: 'I acknowledge that I am a Canadian resident, and I am at least 18 years of age and have been made aware of and understand the terms, conditions and exclusions outlined in the Terms and FAQs',
                QC: 'I acknowledge that I am a Canadian resident, and I am at least 18 years of age and have been made aware of and understand the terms, conditions and exclusions outlined in the Terms, FAQs and Product Summary and Fact Sheet'
            },
            FAQ: {
                title: 'Let’s find out whether this Loan Payment Protection Program(LPPP) will meet your needs',
                subtitle: "FAQ's",
                buttonViewMore: 'View All FAQs',
                buttonViewLess: 'View Less',
                question1: 'What does the LPPP cover?',
                subtitle1_point1:
                    ' If you are eligible, the LPPP provides the following coverages in connection with your Fig loan, up to an aggregate maximum benefit of $35,000:',
                subtitle1_point2_title: 'Involuntary Unemployment coverage:',
                subtitle1_point2:
                    ' If you lose your job, the coverage could make up to 12  months of payments, towards your outstanding Fig loan balance. The total payments will not exceed the lesser of the outstanding balance or $35,000. This coverage also extends to self-employed individuals.',
                subtitle1_point3_title: 'Disability coverage:',
                subtitle1_point3:
                    ' If you become disabled and unable to work, the coverage could make up to  12 months of payments towards your outstanding Fig loan balance.',
                subtitle1_point4_title: 'Critical Illness coverage*:',
                subtitle1_point4:
                    ' If you or your spouse (in Quebec, the coverage is available to the primary borrower only) become diagnosed with a critical illness for the first time and survive that first diagnosis for at least 30 days, the coverage will pay Fig, an amount equal to the outstanding Balance, up to a maximum of $35,000. The coverage will be applied by Fig towards your loan. Critical illness coverage ends at the age of 65.',
                subtitle1_point5_title: 'Life with Dismemberment coverage**:',
                subtitle1_point5:
                    ' If you or your spouse (in Quebec, the coverage is available to the primary borrower only) die or suffer dismemberment, the coverage will pay Fig, an amount of insurance equal to the outstanding balance up to a maximum of $30,000. If the death or dismemberment of you and your spouse occurs simultaneously, only one benefit will be paid.',
                subtitle1_point6:
                    '*The Critical Illness benefit will be paid only once. When you are simultaneously disabled, involuntarily unemployed, or involuntarily unemployed as a self-employed, you are entitled to benefits only under one coverage.',
                subtitle1_point7:
                    '**Before the age of 65 (71 in BC), the Loan Payment Protection Program does not require that death arise from accidental circumstances. Beginning from age 65 (71 in BC) and thereafter, the LPPP only provides coverage if death arises from accidental circumstances and death must occur within 90 days of the accident.',
                question2: 'How to qualify for the coverage?',
                subtitle2_point1: 'To qualify for the Involuntary Unemployment Benefit:',
                subtitle2_point2:
                    'You must be insured under the Policy and gainfully employed on a permanent basis, working full-time at the Date of your Loss, which means working at least 25 hours each week.',
                subtitle2_point3: 'You must be involuntarily unemployed for more than 30 consecutive days.',
                subtitle2_point4:
                    'Prior to your involuntary unemployment, your employer shall have been paying employment insurance premiums to the Canada Revenue Agency (CRA) and/or any of its successor entities, on your behalf.',
                subtitle2_point5: 'You must be insured for at least 30 days after your enrollment date.',
                subtitle2_point6: 'To qualify for the Disability Benefit:',
                subtitle2_point7: 'You become disabled and as a result are unable to work and shall remain totally disabled for more than 30 consecutive days.',
                subtitle2_point8:
                    'You must be regularly attended by a licensed physician or surgeon other than yourself and, in the opinion of the physician or surgeon, be prevented from engaging in any business or employment for which you are reasonably fitted by training, experience or education.',
                subtitle2_point9:
                    'You must have been insured under the Policy and gainfully employed or working in a self-employed capacity earning taxable revenue pursuant to the Canada Income Tax Act on a permanent basis, working full-time at the Date of Loss, which means working at least 25 hours each week.',
                subtitle2_point10: 'To qualify for the Critical Illness Benefit:',
                subtitle2_point11: 'The date of First Diagnosis must occur prior to the individual’s 65th birthday.',
                subtitle2_point12:
                    'The critical illnesses covered under this policy are Cancer (life-threatening), Heart Attack, Stroke, Coronary Artery Bypass Graft, Kidney Failure, and Major Organ Transplant. The Critical Illness must not have resulted directly or indirectly from any of the exclusions found under the ',
                subtitle2_point12_bold_point1: '"What are the exclusions and conditions of the coverage"',
                subtitle2_point12_bold_point2: ' section of this FAQ.',
                subtitle2_point13:
                    'The Critical Illness must not have existed, or was first diagnosed, prior to the Effective Date or within 90 days after the Effective Date.',
                subtitle2_point14: 'Proof of loss must be submitted within 90 days of First Diagnosis.',
                subtitle2_point15: 'To qualify for the Life with Dismemberment Benefit:',
                subtitle2_point16:
                    'Dismemberment must occur through accidental bodily injuries that are sustained directly and independently of all other causes resulting in the total and irrevocable loss of the entire sight of both eyes or a hand or foot by complete severance through or above the wrist or ankle joint.',
                subtitle2_point17: 'The death must not have resulted from any of the exclusions found under the ',
                subtitle2_point17_bold_point1: '"What are the exclusions and conditions of the coverage"',
                subtitle2_point17_bold_point2:
                    ' section of this FAQ; or a pre-existing Condition, if you die within 6 months of the Effective Date from that pre-existing condition.',
                question3: 'How much does the LPPP cost? ',
                subtitle3:
                    'The Premium charged for the Loan Payment Protection Program will be the amount calculated by multiplying the Insurer’s Premium Rate of 15% by the customer’s regular principal and interest payments, plus applicable taxes, payable at the same frequency as the customer’s regular loan payments. ',
                question4: 'How do I make a claim?',
                subtitle4_point1: 'To make a claim, follow these steps to contact Trans Global Insurance Company and Trans Global Life Insurance Company:',
                subtitle4_point2: 'By calling 1-844-930-6022 between 8:00 a.m. and 5:00 p.m. (MST)',
                subtitle4_point3: 'By email clientcare@transglobalinsurance.ca',
                subtitle4_point4: 'By written notice to TRANS GLOBAL INSURANCE GROUP, 16902-137 Ave. NW, Edmonton, AB T5V 0C8.',
                question5: 'Can I cancel my LPPP? ',
                subtitle5_point1:
                    'The Loan Payment Protection Program is optional, and you can cancel it at any time. If you cancel within the first 30 days (60 days in Quebec), the premiums you paid will be refunded to you. If you cancel any time after 30 days (60 days in Quebec), you will not be entitled to any refund of premiums charged.',
                subtitle5_point2: 'Cancellation through Fig:',
                subtitle5_point3:
                    'If you wish to cancel your loan payment protection policy through Fig, simply email us at support@fig.ca. Your policy will be canceled upon receipt of a written confirmation from you.',
                subtitle5_point4: 'Cancellation through Trans Global Life Insurance Company and Trans Global Insurance Company:',
                subtitle5_point5:
                    'A cancellation form will need to be completed, signed, and sent to Trans Global Insurance. If you have any questions regarding this Policy or require claim information, please contact:',
                subtitle5_point6: 'Trans Global Life Insurance Company and Trans Global Insurance Company, 16902-137 Ave. NW, Edmonton, AB T5V 0C8',
                subtitle5_point7: 'Telephone: 1-844-930-6022',
                subtitle5_point8: 'By email clientcare@transglobalinsurance.ca',
                question6: 'What is the Loan Payment Protection Program (LPPP)?',
                subtitle6:
                    'The LPPP is a comprehensive optional insurance program for customers with a Fig loan who have opted-in for the coverage, agreed to pay the premium, and continue to pay premiums on a timely basis. The coverage is underwritten by Trans Global Insurance Company and Trans Global Life Insurance Company.',
                question7: 'Who is Eligible for the coverage?',
                subtitle7_point1: 'To be eligible for the coverage, you must be: ',
                subtitle7_point2: 'A Fig Financial Inc. primary loan borrower',
                subtitle7_point3: 'A Canadian resident',
                subtitle7_point4: 'A person at least 18 years of age.',
                question8: 'Who is covered?   ',
                subtitle8_point1:
                    'The Life and Dismemberment and Critical Illness coverages are available to the primary borrower and their spouse. In Quebec, both coverages are available to the primary borrower only.',
                subtitle8_point2: 'The Disability and Involuntary Unemployment coverages are available only to the primary borrower. ',
                subtitle8_point3: 'The primary borrower is the individual whose name appears on the Fig loan agreement.',
                question9: 'What are the exclusions and conditions of the coverage? ',
                subtitle9_point1: 'General exclusions from the coverage include:',
                subtitle9_point2: 'Intentionally self-inflicted injury;',
                subtitle9_point3: 'Attempted suicide;',
                subtitle9_point4: 'Drug, alcohol, or solvent abuse;',
                subtitle9_point5: 'The commission, or attempted commission, of an illegal act; ',
                subtitle9_point6:
                    'Military service, declared or undeclared war, or any nuclear, chemical, or biological contamination resulting from an act of terrorism.',
                subtitle9_point7:
                    'There are also additional exclusions and conditions that can be found in the Certificate of Insurance. Some of these exclusions relate to pre-existing conditions.  For example, the insurers will not pay a monthly disability benefit if the disability results from a pre-existing condition, which is any sickness or injury for which you received medical advice, consultation, diagnosis or investigations, or for which treatment was required or recommended by a doctor during the 6 months before the effective date of coverage.  The insurers will also not pay a death benefit if you die from a pre-existing condition within 6 months of the effective date.',
                question10: 'When does the insurance start?  ',
                subtitle10:
                    'The effective date of the Loan Payment Protection Program is the date that Trans Global Insurance Company and Trans Global Life Insurance Company receive your application/enrollment for insurance. Fig will notify TGI of the enrollment at the time of the loan booking.',
                question11: 'When does the insurance end? ',
                subtitle11_point1: 'On the sooner of:',
                subtitle11_point2:
                    'The date Trans Global Life Insurance Company or Trans Global Insurance Company  or Fig receive your written confirmation to end the insurance coverage, or ',
                subtitle11_point3:
                    '31 days from the date Trans Global Life Insurance Company or Trans Global Insurance Company  send you written notice, by first class mail to your last known address, to cancel this insurance, or',
                subtitle11_point4: 'The date your Fig loan is terminated, on receipt of notice of termination by the insurer, or',
                subtitle11_point5: 'The date you are more than 31 days late in making any required payment towards your Outstanding Balance, or',
                subtitle11_point6:
                    'If you have deferred your loan payment date, the date you are more than 31 days past due from your last contractual loan payment due date.',
                question12: 'What if I already have other insurance? ',
                subtitle12: 'The LPPP is designed to complement any other coverage you may have.',
                question13: 'How do I make a complaint?',
                subtitle13_point1: 'To make a complaint, follow these steps:',
                subtitle13_point2:
                    'If for some reason you are not satisfied with the resolution to an inquiry or dissatisfaction, please call 1-844-930-6022 between 8:00 am and 5:00 pm (MT), Monday to Friday.',
                subtitle13_point3:
                    'Should you require more information regarding the Insurer’s complaint handling procedure, please visit the Trans Global Insurance website to view the complaint resolution processes which can be found at: https://transglobalinsurance.ca/resolving-complaints/',
                question14: 'Who do I contact if I have questions about the Loan Payment Protection Program?',
                subtitle14:
                    'If you have any questions about this insurance coverage, contact Trans Global Insurance Company and Trans Global Life Insurance Company at 1-844-930-6022 or by email at clientcare@transglobalinsurance.ca.',
                question15: 'What are the consequences of any misrepresentation in my application?',
                subtitle15:
                    'If you misstate your age to us at the time you provide us with your application, the insurers’ liability is limited to a refund of all premiums you have paid.'
            },
            Terms: {
                FirstTitle: {
                    title: 'Terms',
                    point1: 'Insurance is not required as a condition to obtain the loan. The insurance is with Trans Global Insurance Company and Trans Global Life Insurance Company; you are not contracting this insurance with Fig Financial Inc. ',
                    point2: 'Coverage is effective upon enrollment and ceases on the earliest of the dates specified  in the Certificate of Insurance.',
                    point3: 'You will have a 30-day free review period (60 days in Quebec) upon receipt of your  Certificate of Insurance. Should you cancel during this period, the premiums you paid  will be refunded to you. You may also cancel at any time after the free review period by  contacting Fig or the insurer But will not be entitled to a refund of premiums.',
                    point4: 'Fig receives remuneration for performing administrative duties in respect of the Group Policy. This amount is fifty five percent of the premium charged.',
                    point5: 'Benefits are subject to terms and conditions including coverage eligibility, exclusions,  and limitations. Failure to meet eligibility requirements may result in you being ineligible for coverage and potential denial of benefits.',
                    point6: 'For a complete listing of terms and conditions, including information on how to make a  claim, please refer to the Certificate of Insurance that will be provided to you upon enrollment. For Quebec residents, please also review the Summary & Fact Sheet. ',
                    point7: 'Individual circumstances may vary. You may wish to contact the licensed insurer’s  representative or a licensed insurance agent if you need advice about your insurance  needs.'
                },
                SecondTitle: {
                    title: 'Insurer Contact Information',
                    point1: 'Coverage is underwritten by Trans Global Insurance Company and Trans Global Life Insurance  Company Company for residents of provinces outside of Quebec, and exclusively by Trans Global Life Insurance Company for Quebec residents. ',
                    point2: 'Tel: 1-844-930-6022.  ',
                    point3: 'Email: clientcare@transglobalinsurance.ca'
                }
            }
        },
        primeTrust: {
            title: 'Up next: 2 quick steps to complete your application',
            subtitle: 'To protect you from fraud and securely send you funds, we need to verify your identity and connect your bank account.',
            whatsNext: 'What’s next',
            identity: {
                title: 'Verify your identity',
                description: 'Take a photo of your ID and a selfie to confirm your identity.',
                duration: '~ 2 minutes',
                iconAlt: 'Identity verification'
            },
            bank: {
                title: 'Connect your bank account',
                description: 'Securely link your bank to verify your income and deposit your funds.',
                duration: '~ 2 minutes',
                iconAlt: 'Bank account connection'
            },
            security: {
                title: 'Your information is safe with us',
                subtitle: 'We use bank-level security to protect your data and never share it with anyone.'
            },
            buttonText: 'Continue'
        },
        kycIntroStep: {
            title: 'Verify your identity securely',
            subtitle: 'Take a photo of your ID and a selfie to instantly confirm your identity.',
            imageAlt: 'Identity verification introduction',
            qcConsent: {
                checkboxTitle: 'Consent for Quebec identity verification',
                text: 'I consent to the collection and use of my biometric information in connection with my loan application so that Fig Financial Inc. ("Fig" or "we") can verify my identity, detect and prevent fraud, and meet its legal requirements.',
                tooltipContent: `Fig uses an identity verification provider in order to reliably verify your identity. You will be asked to submit a photo of your identification document and take a selfie (photo or video). Your images are used to generate alphanumeric templates of your facial measurements, which are then compared in order to verify that the individual in both images is the same.<br/><br/>We will store the alphanumeric templates of your facial measurements and identification document you provide for up to 12 months in order to detect and prevent fraud and meet our legal requirements. Your personal information may be processed outside of the jurisdiction in which you are located.`
            },
            buttonText: 'Continue'
        },
        kycVerify: {
            pageTitle: 'Verify your identity securely',
            pageSubtitle:
                'We need to confirm your identity to protect you from fraud and meet Canadian regulatory requirements. All it takes is a photo of your ID and a selfie.',
            title: 'Verify your identity securely',
            subtitle: 'Take a photo of your ID and a selfie to instantly confirm your identity.',
            imageAlt: 'Identity verification introduction',
            cobrandAlt: 'Fig powered by Onfido',
            buttonText: 'I have my ID - start verification',
            trust: {
                title: 'Your information is safe and secure',
                poweredBy: 'Powered by <onfido>Onfido</onfido>, a trusted identity verification provider',
                poweredByIconAlt: 'Trusted provider',
                noRawImages: 'Fig never stores your raw ID or selfie images — Onfido processes them securely',
                noRawImagesIconAlt: 'Secure processing',
                fraudOnly: 'Used only to verify your identity and prevent fraud',
                fraudOnlyIconAlt: 'Identity verification'
            },
            crossDeviceTitle: 'Mobile session linked to your Fig loan application',
            crossDeviceInfo1: 'This link was sent by you - stop if this link is sent to you by someone else.',
            crossDeviceInfo2: 'Your desktop window remains open',
            crossDeviceBtn: 'Continue Fig loan application',
            onfidoDocumentPassport: 'Canadian passport',
            onfidoDocumentDriversLicense: "Canadian driver's license",
            playgroundPlaceholder: 'Identity verification (Onfido) is not available in the design playground. Use staging or production to run the full flow.',
            playgroundContinue: 'Continue to next step (preview)'
        },
        kycGenericRetry: {
            title: 'Sorry, we couldn’t verify your identity due to an information mismatch. Please confirm your information from your uploaded document below and try again.',
            subtitle:
                'There were some issues verifying your documents. Please note that health cards and foreign passports are not supported. Please try again or visit our to learn more.',
            buttonText: 'Verify ID again'
        },
        kycImageRetry: {
            title: 'Please verify your identity again',
            subtitle: 'Sorry, we couldn’t verify your identity due to the image quality of your uploaded document.',
            tips: {
                title: 'Tips',
                tip1: 'If you used a passport, capture only the bottom portion that contains information, or use a driver’s license if applicable',
                tip2: 'Avoid shadows and obstructions (i.e. finger) on your image',
                tip3: 'Choose a well lit environment and mobile device with a capable camera'
            },
            buttonText: 'Verify ID again'
        },
        kycPiiRetry: {
            title: 'Please confirm your information and verify your identity again.',
            subtitle:
                'Sorry, we couldn’t verify your identity due to an information mismatch. Please confirm your information from your uploaded document below and try again.',
            disclaimer: 'If you think there was a mistake, please reach out to us via Fig live chat to the bottom right of this page or email Fig support.',
            buttonText: 'Confirm and verify ID again',
            firstName: {
                label: 'First name',
                placeholder: 'Enter your first name'
            },
            lastName: {
                label: 'Last name',
                placeholder: 'Enter your last name'
            }
        },
        kycPermissionsScreen: {
            title: 'Oops, please allow camera and microphone permissions to continue',
            subtitle: 'We could not proceed ID verification due to your app’s permission issue.',
            solutionText: 'Solution: switch to browser',
            solutionStep1: 'Copy the URL below',
            solutionStep2: 'Paste and open URL in your browser',
            solutionStep3: 'Complete your application again',
            buttonText: 'Copy URL'
        },
        reviewStep: {
            title: 'Let’s confirm your loan details',
            change: 'Change',
            loansDetail: {
                title: 'Loan details',
                loanInformation: 'You’re borrowing {{amount}} over {{term}} years ({{apr}} APR)',
                loanAmount: 'Loan Amount',
                interestAmount: 'Interest Amount',
                totalAmount: 'Total Repayment Amount'
            },
            paymentProtection: {
                title: 'Payment protection plan',
                accepted: 'Your payments are protected',
                declined: 'Your payments are not protected'
            },
            paymentSchedule: {
                title: 'Payment schedule',
                details: 'You’ll pay {{amount}} on a {{frequency}} basis',
                loanPayment: 'Loan payment',
                paymentProtectionPremium: 'Payment protection premium',
                taxPaymentProtectionPremium: 'Tax on payment protection',
                total: 'Total payment',
                firstPaymentDate: 'First payment date',
                paymentFrequency: {
                    every_week: 'weekly', // Weekly
                    every_two_weeks: 'biweekly', // Biweekly
                    once_a_month: 'monthly' // Monthly
                }
            },
            paymentMethod: {
                title: 'Payment method'
            },
            terms: {
                loanAgreement: "I agree to Fig's <0>loan agreement</0>",
                loanAgreementDetails: 'Psst - this one’s important',
                loanAgreementTitle: 'Required: Agree to loan agreement to proceed',
                padAgreement:
                    'I authorize Fig to automatically withdraw payments that are due from my account according to the <0>pre-authorized debit agreement</0>',

                padAgreementTitle: 'Required: Agree to pre-authorized debit agreement to proceed',
                creditCheck:
                    'I authorize Fig to conduct a one-time hard credit check and, throughout the term of the outstanding loan, periodic soft credit checks with TransUnion. These checks are essential to processing my loan application, assessing my creditworthiness, and effectively managing my loan.',

                creditCheckTitle: 'Required: Authorize credit check to proceed',
                newsLetter: 'Fig can occasionally send me electronic messages about its products and services (optional)',
                newsLetterDetails: 'Don’t worry, we don’t like spam either',
                newsLetterTitle: 'Optional: Receive electronic messages about Fig products and services',
                loanAgreementTitleQC: 'Quebec Loan Agreement',
                padAgreementTitleQC: 'Quebec Pre-authorized Debit Agreement',
                agree: 'Agree',
                kizzo: {
                    loanAgreement: 'I agree to the <0>loan agreement</0> with Fig Financial Inc. doing business as Kizzo.',
                    padAgreement: 'I authorize automatic withdraws from my account for payments due according to the <0>pre-authorized debit agreement</0>',
                    creditCheck:
                        'I authorize a one-time hard credit check and, throughout the term of the outstanding loan, periodic soft credit checks with TransUnion. These checks are essential to processing my loan application, assessing my creditworthiness, and effectively managing my loan.'
                }
            },
            error: {
                selected_payment_date_invalid:
                    'Your first payment date cannot be in the past or within the next 7 days. Please change your Payment Schedule above'
            },
            cta: {
                buttonText: 'Book my loan',
                disclaimer: 'Your loan will start immediately. Funds usually take between 1 to 2 business days before appearing in your account.'
            }
        },
        finishStep: {
            title: 'Congratulations on booking your loan!*',
            loanId: 'Loan # {{loanId}}',
            subtitle:
                'You can expect to receive your money within the next 1-2 business days.* Check your inbox for an e-mail with all the details of your loan.',
            questionsTitle: 'Questions?',
            questionsSubtitle: 'Visit our help centre for any questions you have about your loan or next steps.',
            termsText:
                '* We may reach out to you to conduct additional verifications on information which you have provided.  In such cases, your cooperation is required for us to continue to process your loan.',
            buttonText: 'Go to help centre'
        },
        pendingFinish: {
            title: 'Thank you for your loan application!',
            loanId: 'Loan # {{loanId}}',
            body: 'We’re almost done. Our automated verification system will call you within 1 business day to verify a few details so we can process your loan.',
            callout: {
                title: 'Expect an automated call from <nowrap>1-888-528-5572</nowrap>',
                note: 'Please note: this number does not receive incoming calls.'
            },
            question: 'Questions?',
            answer: 'Visit our help centre for any questions you have about your loan or next steps.',
            buttonText: 'Go to help centre'
        },
        connectBankAccount: {
            title: 'We use Flinks to connect your account for faster approval',
            subtitle: 'This helps us verify your ability to repay the loan through transaction history and deposit your funds.',
            infoBox: {
                privacyTitle: "It's private",
                privacySubtitle: 'Your credentials will not be shared with {{partner}}',
                securityTitle: 'It’s secure',
                securitySubtitle: '500k+ monthly users trust Flinks to securely connect to financial institutions'
            },
            tooltipTitle: 'Why do we need this?',
            disclaimer: `By selecting ‘Continue’ you agree to the <0>Flinks’ Services Privacy Statement</0>`,
            disclaimerLink: 'https://www.flinks.com/privacy-policy',
            buttonText: 'Continue',
            ctaDisclaimer: `All connections are secure and encrypted`,
            tooltip: {
                title: 'Why do we need this?',
                line1: '1. To verify the information you provided and your ability to repay the loan',
                line2: '2. To prevent fraud',
                line3: '3. To deposit your funds & set up pre-authorized payments',
                line4: '4. To skip paperwork for faster approval',
                disclaimer: {
                    text: 'We collect information such as transaction history and contact information for the purposes above. You can withdraw your consent to the collection and use of your bank account information at any time by closing your loan with us. Learn more by visiting our <learnMoreLink>Privacy Statement</learnMoreLink>.',
                    linkUrl: 'https://www.flinks.com/privacy-policy'
                }
            }
        },
        flinksConnect: {
            selectInstitution: {
                title: 'Where’s your bank account?',
                subtitle: 'Select the financial institution of your preferred or primary bank account.'
            },
            enterCredentials: {
                title: 'Enter the login details you use for your online banking',
                subtitle: "Enter your credentials to connect your account. We use your trusted bank's security and privacy"
            }
        },
        flinksStatusCheck: {
            loadingSubtitle: 'We are linking your bank account. This may take a few minutes.',
            successSubtitle: 'You have successfully linked your bank account!',
            errorSubtitle: 'An error occurred while checking your bank account status.',
            declinedSubtitle: 'Your bank account verification was declined.'
        }
    }
}
